import { DataRef } from "../../../types/DataRef";
import {
  Box,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { Dispatch, FC, Fragment, useEffect, useState } from "react";
import { IBu, MenuProps } from "../../content/parametrage/Bu/Bu";
import { IPays } from "../../content/parametrage/Pays/Pays";
import { LoadingButton } from "@mui/lab";
import AddIcon from "@mui/icons-material/Add";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import CheckAttr from "../../../utils/CheckAttr";
import { AxiosInstance } from "axios";
import { AlertType } from "../../../types/AlertType";

interface ISecteurForm {
  row?: DataRef;
  onClose: () => void;
  reloadList: () => void;
  setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
  setAlerteMessage: Dispatch<React.SetStateAction<string>>;
  setAlertType: Dispatch<React.SetStateAction<AlertType>>;
  http: AxiosInstance;
}

interface InputValidation {
  libelle: boolean;
}

const resetInpuValidation: InputValidation = {
  libelle: false,
};

const SecteurActiviteForms: FC<ISecteurForm> = ({
  row,
  onClose,
  reloadList,
  setOpenSnack,
  setAlerteMessage,
  setAlertType,
  http,
}) => {
  const [libelleAjouter, setLibelleAjoute] = useState<string>(
    row?.id ? row.libelle : ""
  );
  const [isClickSave, setIsClickSave] = useState<boolean>(false);
  const [errorInput, setErrorInput] =
    useState<InputValidation>(resetInpuValidation);

  const isValidate = (): boolean => {
    // Reinitialise les variables des validations
    setErrorInput(resetInpuValidation);

    if (!CheckAttr(libelleAjouter)) {
      if (!CheckAttr(libelleAjouter)) {
        setErrorInput((prev: InputValidation) => ({ ...prev, libelle: true }));
      }

      setAlerteMessage("Merci de remplir les champs en rouge !");
      setAlertType("warning");
      setOpenSnack(true);

      return false;
    }
    return true;
  };

  const handleSave = () => {
    if (isValidate()) {
      setIsClickSave(true);
      const data = {
        id: row?.id,
        libelle: libelleAjouter,
      };
      console.log(data);
      http
        .post(`secteuract/addupdate`, data)
        .then((res) => {
          if (res.data === 1) {
            setAlerteMessage("Creation Secteur avec success");
            setAlertType("success");
            setOpenSnack(true);
            onClose();
            reloadList();
          } else {
            setAlerteMessage(res.data);
            setAlertType("warning");
            setOpenSnack(true);
          }
        })
        .finally(() => {
          setIsClickSave(false);
        });
    }
  };
  return (
    <Fragment>
      <Grid container spacing={2} columns={{ xs: 6, sm: 6, md: 6 }}>
        <Grid item xs={6} sm={6} md={6}>
          <TextField
            label="Libelle secteur Activite"
            color="warning"
            fullWidth
            error={errorInput.libelle}
            value={libelleAjouter}
            onChange={(e) => setLibelleAjoute(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
      </Grid>
      <Box display="flex" justifyContent="center" mt={5}>
        <LoadingButton
          onClick={() => handleSave()}
          endIcon={row ? <BorderColorIcon /> : <AddIcon />}
          loading={isClickSave}
          loadingPosition="end"
          sx={{ textTransform: "none" }}
          variant="contained"
          color="warning"
        >
          {row ? "Enregistrer" : "Ajouter"}
        </LoadingButton>
      </Box>
    </Fragment>
  );
};

export default SecteurActiviteForms;
